import React, { useMemo } from 'react'
import AuctionDetails from './auctionDetails'
import { CardImage, AddressInfo, PropertyInfo, Button } from '@adc/ui-core'
import { type CurrentTargetAudience, Listing } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
import * as graph from '@adc/sdk'

const cx = classnames.bind(styles)

type InfoCardProps = {
  thumbnail?: React.ReactNode
  listing: Listing
  viewingFrom?: CurrentTargetAudience
  onEditListing: () => void
}
const ListingInfoCard = (props: InfoCardProps) => {
  const { listing, viewingFrom, onEditListing } = props

  const thumbnail = useMemo(() => {
    if (props.thumbnail) {
      return props.thumbnail
    }

    return (
      <CardImage
        // @ts-ignore next
        listing={listing}
        className={cx('image')}
        viewingFrom={viewingFrom}
      />
    )
  }, [listing, props.thumbnail, viewingFrom])

  const editListingEnabled =
    viewingFrom &&
    [
      graph.enums.CurrentTargetAudience.Seller,
      graph.enums.CurrentTargetAudience.Staff,
    ].includes(viewingFrom) &&
    [
      graph.enums.ListingStatus.AuctionInProgress,
      graph.enums.ListingStatus.SalePending,
      graph.enums.ListingStatus.EligibilityPending,
      graph.enums.ListingStatus.InStaging,
    ].includes(listing.listing_status)

  return (
    <div
      data-elm-id={`listing-info-card-${listing?.listing_id}`}
      className={cx('listing-info-card-section')}
    >
      {thumbnail}
      <AddressInfo
        address={listing?.formatted_address}
        className={cx('property-address')}
        elmId={`listing-info-card-address-info-${listing?.listing_id}`}
      />
      <PropertyInfo
        listing={listing}
        className={cx('property-info')}
        elmId={`listing-info-card-property-info-${listing?.listing_id}`}
      />
      <AuctionDetails listing={listing} viewingFrom={viewingFrom} />
      {editListingEnabled ? (
        <div className={cx('button-container')}>
          <Button
            role='secondary'
            isStretch
            onClick={() => onEditListing?.()}
            elmId={`edit-listing-button-${listing?.listing_id}`}
          >
            Edit Listing
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default ListingInfoCard
